module.exports = __webpack_public_path__ + "static/media/silver.9238d623.png";